import { computed } from 'vue';

const useTableRow = ($listeners, emits) => {
  const onTableRowKeyClick = (item) => {
    emits("table-row-key-click", item);
  };
  const hasTableRowKeyClickListener = computed(
    () => $listeners !== void 0 && Object.prototype.hasOwnProperty.call($listeners, "table-row-key-click")
  );
  const onTableRowClick = (item) => {
    emits("table-row-click", item);
  };
  const hasTableRowClickListener = computed(
    () => $listeners !== void 0 && Object.prototype.hasOwnProperty.call($listeners, "table-row-click")
  );
  const tableRowAttributes = computed(() => ({
    class: {
      "fds-table__row": true,
      "fds-table__row--link": hasTableRowClickListener.value
    },
    tabindex: hasTableRowClickListener.value ? 0 : void 0,
    role: hasTableRowClickListener.value ? "link" : void 0
  }));
  const tableRowEvents = (item) => ({
    click: (e) => {
      e.preventDefault();
      onTableRowClick(item);
    },
    keyup: (e) => {
      if (e.key === "Enter") {
        onTableRowClick(item);
      }
    }
  });
  return {
    onTableRowKeyClick,
    hasTableRowKeyClickListener,
    onTableRowClick,
    hasTableRowClickListener,
    tableRowAttributes,
    tableRowEvents
  };
};

export { useTableRow };
